import { render, staticRenderFns } from "./NewDarfPayment.vue?vue&type=template&id=db20bc8c"
import script from "./NewDarfPayment.vue?vue&type=script&lang=js"
export * from "./NewDarfPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports